<template>
  <div class="main_mfd">
    <!-- 顶部 -->
    <div class="bread_nav clearfix">
      <div class="return clearfix" @click="$router.go(-1)">
        <img src="../assets/img/返回.png" alt />
        返回上一页
      </div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">轻课</el-breadcrumb-item>
        <el-breadcrumb-item>知识点学习</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 内容区域 -->
    <div class="mainBox">
      
      <div class="progressBox" style="padding-bottom:30px;border-bottom:1px solid #eeeeee" v-if="class_list">
        <div class="title" style="font-size:20px;font-weight:bold">知识点学习</div>
        <div class="over_lore clearfix" style="display:flex;margin-top:20px">
          <div class="name">知识点：</div>
          <div class="proge" style="width:350px;margin:0 10px">
            <el-progress :percentage="class_list.knowledge_data.do_count*100/class_list.knowledge_data.total_count" :show-text="false" :stroke-width="18"></el-progress>
          </div>
          <div class="number" v-if="class_list">
            <span>{{class_list.knowledge_data.do_count||0}}</span>/{{class_list.knowledge_data.total_count||0}}
          </div>
        </div>
        <div class="over_lore clearfix" style="display:flex;margin-top:20px">
            <div class="name">总题目：</div>
            <div class="proge1" style="width:350px;margin:0 10px">
                <el-progress :percentage="class_list.question_data.do_count*100/class_list.question_data.total_count" :show-text="false" :stroke-width="18"></el-progress>
            </div>
            <div class="number" v-if="class_list">
              <span>{{class_list.question_data.do_count}}</span>/{{class_list.question_data.total_count||0}}
            </div>
        </div>
      </div>

      <div class="row" v-for="(item,index) in class_list.knowledge_list" :key="index">
        <div class="box" @click="tab_show(index,item,class_list.knowledge_list)" v-if="item.children.length>0">
          <div class="left">
            <img src="../assets/img/zhankai2.png" alt="" v-if="item.show" />
            <img src="../assets/img/zhankai.png" alt="" v-else />
            {{item.name}}
          </div>
          <div class="right">
            <!-- <span style="color:red">{{item.do_count}}</span>
                /{{item.total_count}}道
            <button @click.stop="makeQuestion(item)">做题</button> -->

            <div class="btn">{{item.show?'收起学习':'展开学习'}}</div>
          </div>
        </div>

        <div class="subBox" v-if="item.show">
          <div v-for="(item1,index) in item.children" :key="index">
            <div class="subRow">
              <div class="left">
                <img src="../assets/img/dott.png" alt="" />
                {{item1.name}}
              </div>
              <!-- <div class="right">
                <span style="color:red">{{item1.do_count}}</span>
                /{{item1.total_count}}道
                <button @click.stop="makeQuestion(item1,2)">做题</button>
              </div> -->
            </div>
            <!-- 三层 -->
            <div class="subBox subBox2" v-for="item2 in item1.children">
              <div class="subRow">
                <div class="left">
                  <img src="../assets/img/dott.png" alt="" />
                  {{item2.name}}
                  <p style="padding:7px 0 0 17px">
                    <img src="../assets/img/star.png" alt="" style="width:18px !important;height:18px !important;margin-right:8px" v-for="item in item2.star_level">
                  </p>
                </div>
                <!-- <div class="right">
                  <span style="color:red">{{item2.do_count}}</span>
                    /{{item2.total_count}}道
                  <button @click="goVideo(item2)" v-if="item2.video_id" style="margin-right:0 !important">看视频</button>
                  <button @click.stop="makeQuestion(item2,2)">做题</button>
                </div> -->
                <div class="right">
                  <span style="color:#0091FF;margin-top:2px" v-if="item2.video_info&&item2.video_info.progress_rate">观看{{item2.video_info.progress_rate}}%</span>
                  <div class="btnBox">
                    <button @click="goVideo(item2)" v-if="item2.video_id"><img src="../assets/img/play2.png" alt="">看视频</button>
                    <div class="text" v-if="item2.video_info&&item2.video_info.duration_format">{{item2.video_info.duration_format}}</div>
                  </div>
                  <div class="btnBox">
                    <button @click="makeQuestion(item2,3)"><img src="../assets/img/pen.png" alt="">做题</button>
                    <div class="text"><span style="color:#FE4C4B">{{item2.do_count}}</span>/{{item2.total_count}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    
    </div>


  </div>
</template>

<script>
import { knowledgeList } from "@/api/index";
export default {
  name: "",
  data() {
    return {
      class_list: '', //列表
    };
  },
  computed: {},
  watch: {},
  methods: {
    request() {
      knowledgeList(this.$route.query.id).then(res => {
        this.class_list = res.data;
        for (let i = 0; i < this.class_list.knowledge_list.length; i++) {
          // this.class_list.knowledge_list[i].show = false;
          this.$set(this.class_list.knowledge_list[i],'show',false)
          for(let j=0;j<this.class_list.knowledge_list[i].children.length;j++){
            this.$set(this.class_list.knowledge_list[i].children[j],'show',false)
          }
        }
        console.log(this.class_list)
      });
    },
    // 点击显示隐藏
    tab_show(index, item,allItem) {
      let show = !item.show
      allItem.forEach(item2=>{this.$set(item2,'show',false)})
      this.$set(item,'show',show)
    },
    // 看视频
    goVideo(item){
      console.log(item)
      sessionStorage.setItem("id", item.id);
      this.$router.push({ path: "playbackZsd",query: {
          knowledge_id:item.id,
          type:2,
          course_id: this.class_list.course_id,
          chapter_id: item.id,
          k_id: this.$route.query.chapter_id,
          rule_tag: this.class_list.rule_tag,
          course_chapter_id:item.id,
          isLoad:1,
        }
      });
    },
    // 点击做题
    makeQuestion(item,level){
      this.$router.push({
          path: "workZsdxx",
          query: {
            course_id: this.class_list.course_id,
            chapter_id: item.id,
            k_id: this.$route.query.chapter_id,
            rule_tag: this.class_list.rule_tag,
            course_chapter_id:item.id,
            knowledge_id:item.id
          }
        });
    },

  },
  created(){
    this.request();
  },
  beforeRouteEnter(to, from, next) {
    console.log(to,from)
    next();
  },
  beforeRouteLeave(to, from, next) {
    // if (to.path == "/superClass") {
    //   from.meta.keepAlive = false;
    // }
    if(to.path=='/workZsdxx'){
      from.meta.keepAlive = true;
    }else{
      from.meta.keepAlive = false;
    }
    next();
  },





  
};
</script>

<style lang='scss' scoped>
.main_mfd {
  .bread_nav {
    padding: 12px 0 12px 74px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(238, 238, 238, 1);
    margin-bottom: 16px;
    .return {
      font-size: 16px;
      font-weight: 500;
      color: rgba(43, 43, 43, 1);
      float: left;
      margin-right: 45px;
      line-height: 28px;
      cursor: pointer;
      img {
        float: left;
        width: 28px;
        height: 28px;
        margin-right: 12px;
      }
    }
    .el-breadcrumb {
      float: left;
      margin-top: 8px;
    }
  }
  .mainBox {
    margin-top: 16px;
    background: white;
    padding: 29px 82px 48px 53px;
    .row {
      width: 100%;
      border-bottom: 1px solid #eeeeee;
      overflow: hidden;
      .box {
        height: 73px;
        overflow: hidden;
        cursor: pointer;
        .left {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          float: left;
          display: flex;
          align-items: center;
          height: 100%;
          img {
            width: 18px;
            margin-right: 7px;
          }
        }
        .right {
          float: right;
          display: flex;
          align-items: center;
          height: 100%;
          span {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
          button {
            margin-left: 24px;
            margin-right: 22px;
            width: 72px;
            height: 25px;
            background: #fada1e;
            border-radius: 4px;
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            border: 0;
          }
          .btn{
            width: 72px;
            height: 25px;
            line-height: 25px;
            text-align: center;
            border-radius: 13px;
            border: 2px solid #FADA1E;
          }
        }
      }
      .subBox {
        width: 100%;
        background: #f9f9f9;
        // margin-top: 25px;
        padding: 22px 0 0 17px;
        box-sizing: border-box;
        .subRow {
          overflow: hidden;
          height: 52px;
          .left {
            float: left;
            img {
              width: 14px;
              margin-right: 5px;
            }
          }
          .right {
            float: right;
            font-size: 12px;
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }
            button {
              margin-left: 24px;
              margin-right: 22px;
              width: 72px;
              height: 25px;
              background: #fada1e;
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #000000;
              border: 0;
            }
          }
        }
      }
      .subBox2{
        padding-top: 0;
        padding-left: 45px;
        margin-bottom: 24px;
        img{
          width: 10px !important;
          height: 10px;
        }
        .subRow{
          height: initial;
          .right{
            display: flex;
            .btnBox{
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              button{
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 14px;
                img{
                  width: 16px !important;
                  height:16px !important;
                  margin-right: 1px;
                }
              }
              .text{
                margin-top: 5px;
              }
            }
          }
        }
        
        
        
      }
    }
  }
  .delBox{
    // padding:0 19px;
    
    .delType{
      border-bottom:1px solid #EEEEEE;
      height:36px;
      line-height:36px;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      display:flex;
      justify-content: space-between;
      align-items: center;
      img{
        width:20px;
        height: 20px;
      }
    }

    button{
      width: 165px;
      height: 31px;
      background: #FADA1E;
      border-radius: 14px;
      display: block;
      margin: 10px auto;
      border: 0;
      cursor: pointer;
    }

  }
}
</style>
<style lang="scss">
.main_mfd {
  .el-progress-bar__inner {
    background-color: #fadc1e;
  }
}
</style>